import p, { createElement as O } from "react";
import T from "classnames";
import c from "./index253.mjs";
import { TYPOGRAPHY_BASE_CLASS as H, TYPOGRAPHY_RENDER_AS as m, TYPOGRAPHY_SIZES as i, TYPOGRAPHY_TEXT_ALIGN as N, TYPOGRAPHY_TEXT_DECORATION as f, TYPOGRAPHY_TEXT_TRANSFORM as G, TYPOGRAPHY_WEIGHTS as g } from "./index168.mjs";
import { sanitize as u } from "./index254.mjs";
const E = ({
  as: e = m.SPAN,
  classes: t = "",
  color: s = "undefined",
  ellipsis: r = !1,
  margin: l = "0 0 8px 0",
  size: n = i[0],
  style: o = {},
  text: a,
  textAlign: A = N.START,
  textDecoration: R = f.NONE,
  textTransform: _ = G.NONE,
  weight: S = g.REGULAR,
  "data-testid": Y = `typography-${e}`,
  sanitizeText: P = !1,
  selectable: d = !0,
  ...$
}) => O(
  e,
  {
    "data-testid": Y,
    className: T([
      c[H],
      c[`${H}--${S}`],
      c[`${H}--${n}`],
      c[`${H}--${s}`],
      c[`${H}--${_}`],
      c[`${H}--text-align-${A}`],
      r && c[`${H}--ellipsis`],
      d && c[`${H}--selectable`],
      t
    ]),
    style: { ...o, textDecoration: R, margin: l },
    ...P ? { dangerouslySetInnerHTML: { __html: u(a) } } : {},
    ...$
  },
  P ? void 0 : a
), L = ({
  classes: e,
  color: t,
  margin: s,
  style: r,
  text: l,
  textAlign: n,
  textTransform: o,
  weight: a
}) => /* @__PURE__ */ p.createElement(
  E,
  {
    as: m.P,
    classes: T([c.paragraph, e]),
    color: t,
    margin: s,
    style: r,
    textAlign: n,
    textTransform: o,
    weight: a,
    text: l
  }
), z = ({
  classes: e,
  color: t,
  margin: s = "0 0 16px 0",
  style: r,
  text: l,
  textAlign: n,
  textTransform: o,
  weight: a
}) => /* @__PURE__ */ p.createElement(
  E,
  {
    as: m.H1,
    classes: T([c.H1, e]),
    color: t,
    margin: s,
    style: r,
    text: l,
    textAlign: n,
    textTransform: o,
    weight: a
  }
), X = ({
  classes: e,
  color: t,
  margin: s = "0 0 16px 0",
  style: r,
  text: l,
  textAlign: n,
  textTransform: o,
  weight: a
}) => /* @__PURE__ */ p.createElement(
  E,
  {
    as: m.H2,
    classes: T([c.H2, e]),
    color: t,
    margin: s,
    style: r,
    text: l,
    textAlign: n,
    textTransform: o,
    weight: a
  }
), C = ({
  classes: e,
  color: t,
  margin: s = "0 0 16px 0",
  style: r,
  text: l,
  textAlign: n,
  textTransform: o,
  weight: a
}) => /* @__PURE__ */ p.createElement(
  E,
  {
    as: m.H3,
    classes: e,
    color: t,
    margin: s,
    size: i[3],
    style: r,
    text: l,
    textAlign: n,
    textTransform: o,
    weight: a
  }
), D = ({
  classes: e,
  color: t,
  margin: s = "0 0 16px 0",
  style: r,
  text: l,
  textAlign: n,
  textTransform: o,
  weight: a
}) => /* @__PURE__ */ p.createElement(
  E,
  {
    as: m.H4,
    classes: e,
    color: t,
    margin: s,
    size: i[2],
    style: r,
    text: l,
    textAlign: n,
    textTransform: o,
    weight: a
  }
), M = ({
  classes: e,
  color: t,
  margin: s = "0 0 16px 0",
  style: r,
  text: l,
  textAlign: n,
  textTransform: o,
  weight: a
}) => /* @__PURE__ */ p.createElement(
  E,
  {
    as: m.H5,
    classes: e,
    color: t,
    margin: s,
    size: i[1],
    style: r,
    text: l,
    textAlign: n,
    textTransform: o,
    weight: a
  }
);
export {
  z as H1,
  X as H2,
  L as Paragraph,
  C as SubHeading1,
  D as SubHeading2,
  M as SubHeading3,
  H as TYPOGRAPHY_BASE_CLASS,
  m as TYPOGRAPHY_RENDER_AS,
  i as TYPOGRAPHY_SIZES,
  N as TYPOGRAPHY_TEXT_ALIGN,
  f as TYPOGRAPHY_TEXT_DECORATION,
  G as TYPOGRAPHY_TEXT_TRANSFORM,
  g as TYPOGRAPHY_WEIGHTS,
  E as Typography,
  E as default
};
